import {getDirectory} from "../api/directory_api";
import {DataTable} from "./ui/dataTable";
import {PermissionedDirectoryEntry} from "@models/permissions";
import {
    WithLoggedInAuthInfoProps,
    withRequiredAuthInfo,
} from "@propelauth/react";
import {ColumnDef} from "@tanstack/react-table";
import React, {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";

import {Button} from "./ui/button";
import {UserContext} from "../contexts/UserContext";
import InviteBidderByEmail from "./directory/InviteByEmail";
import {LinkedCell, SortableHeader} from "./ui/tableUtils";
import InviteTeamMember from "./directory/InviteTeamMember";

export const company_directory_columns: ColumnDef<PermissionedDirectoryEntry>[] =
    [
        {
            header: ({column}) => (<SortableHeader column={column} name={"Name"}/>),
            accessorKey: "user.name",
        },
        {
            header: ({column}) => (<SortableHeader column={column} name={"Company"}/>),
            accessorKey: "company.name",
            accessorFn: (row) => row.company?.name || 'company.name',
        },
        {
            header: ({column}) => (<SortableHeader column={column} name={"Title"}/>),
            accessorKey: "user.title",
        },
        {
            header: ({column}) => (<SortableHeader column={column} name={"Email"}/>),
            accessorKey: "user.email",
            cell: ({row}) => (
                <Link
                    to={`/profile/${row.original.user.email}`}>
                    {row.original.user.email}
                </Link>)
        }
    ];

export const project_directory_columns: ColumnDef<PermissionedDirectoryEntry>[] =
    [
        {
            header: "Type",
            accessorKey: "permission_target_type",
        },
        ...company_directory_columns,
    ] 

/**
 * Simple component that displays a table of directory entries
 * we are going to make an API call to get the directory entries....
 * */
function ProjectDirectoryView(props: WithLoggedInAuthInfoProps) {
    const {project_id} = useParams<string>();
    const [directoryEntries, setDirectoryEntries] = useState<PermissionedDirectoryEntry[]>([]);
    const userContext = React.useContext(UserContext);

    useEffect(() => {
        getDirectory(project_id as string, props.accessToken)
            .then((data) => {
                console.log("directory", data);
                setDirectoryEntries(data);
            })
            .catch((error) => {
                console.log("error", error);
            });
    }, [project_id]); // note props.accessToken is not included - no need to refresh project when it changes

    const onInvite = (email: string) => {
    };

    const onTeamMemberAdded = (email: string) => {
    };

    if(directoryEntries.length === 0){return <></>;}

    return (
        <div>
            <div className={"container mx-auto flex items-center h-16 px-4"}>
                <div className="flex-1"></div>
                <div className="flex items-center ml-auto">
                    <InviteTeamMember
                        onInvite={onTeamMemberAdded}
                        currentUsers={directoryEntries.map(x=>x.user.email)}/>

                    {userContext?.company_type === "developer" ? (
                        <InviteBidderByEmail
                            onInvite={onInvite}/>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <br/>
            {directoryEntries.length > 0 ? (
                <DataTable
                    data={directoryEntries}
                    columns={project_directory_columns}
                />
            ) : (
                <></>
            )}
        </div>
    );
}

export default withRequiredAuthInfo(ProjectDirectoryView);
